import { useMutation, useQueryClient } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { readComplianceBody } from "../helper/readComplianceBody";
import type { FraudGlRuleApi } from "./useGetFraudRules";

type StoredToken = { AccessToken?: string };

export type SetFraudRuleActivePayload = { active: boolean };

const setFraudRuleActive = async ({
  active,
}: SetFraudRuleActivePayload): Promise<FraudGlRuleApi | undefined> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(token?.AccessToken);

  const response = await PrivateAdminPanelInstance.post(
    API_ROUTES.POST_FRAUD_RULE_SET_ACTIVE,
    { active },
  );
  return readComplianceBody<FraudGlRuleApi>(response);
};

export const useToggleFraudRuleStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: setFraudRuleActive,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GET_FRAUD_RULE"] });
    },
  });
};
